(function () {
    'use strict';

    function entityDataService($http) {
        var baseUrl = '[BuildifyApiHost]/api/entities';

       function createEntity(entity) {
           return $http.post(baseUrl, entity).then(
                function (response) {
                    return response.data;
                },
                function (response) {
                    var errorResponse = {
                        data: response.data,
                        isError: true
                   }
                    return errorResponse;
                }
            );
       };

        return {
            createEntity: createEntity
        }
    }

    entityDataService.$inject = ['$http'];

    angular.module('ecap.common').service('entityDataService', entityDataService);
})();
